export const formatHtmlToText = (html) => {
  if (!html) return "";

  // Replace <br> and <br/> with newline
  let formatted = html.replace(/<br\s*\/?>/gi, "\n");

  // Replace closing paragraph/div tags with newline
  formatted = formatted.replace(/<\/(p|div)>/gi, "\n");

  // Remove remaining HTML tags
  formatted = formatted.replace(/<[^>]+>/g, "");

  return formatted.trim();
};

export const limitText = (text, limit = 50) => {
  if (!text) return "";

  return text.length > limit ? text.substring(0, limit) + "..." : text;
};
